import makeApiCall from "./axiosIndex";
const contractorsApis = {
  fetchContractor: (): Promise<any> =>
    makeApiCall({ method: "get", url: "/buyer/fetchContractor" }),
  deleteContractorById: (id: any): Promise<any> =>
    makeApiCall({
      method: "delete",
      url: `/buyer/deleteContractorById?id=${id}`,
    }),
  createContractor: (data: any): Promise<any> =>
    makeApiCall({ method: "post", url: "/buyer/createContractor", data }),
  updateContractorById: (id: any, data: any): Promise<any> =>
    makeApiCall({ method: "put", url: `/buyer/updateContractorById?id=${id}`, data }),
  fetchContractorById: (id: any): Promise<any> =>
    makeApiCall({ method: "get", url: `/buyer/fetchCOntractorById?id=${id}` }),
  fetchContractorBySiteId: (data: any): Promise<any> =>
    makeApiCall({
      method: "post",
      url: "/buyer/fetchContractorBySiteId",
      data,
    }),
};

export default contractorsApis;
